import {
    ComposedPumpFunQuick,
    ComposedPumpUpQuick,
    ComposeType,
    Condition,
    DEFAULT_COMPOSED_PUMP_FUN_QUICK,
    DEFAULT_COMPOSED_PUMP_UP_QUICK,
    RuleType
} from "@types";
import React, {FC} from "react";
import {SelectComposeType} from "./type.tsx";
import {PumpFunComposeQuick} from "./main";
import {PumpUpComposeQuick} from "@components/editor/condition/main/pumpup-quick.tsx";

export type ConditionEditorProps = {
    ruleType: RuleType;
    condition: Condition;
    onChange: (condition: Condition) => void;
    onTypeChange: (condition: Condition) => void;
};

export const ConditionEditor: FC<ConditionEditorProps> = ({ruleType, condition, onChange, onTypeChange}) => {
    // @ts-ignore
    const type: ComposeType = condition.composition;

    const supported = [];
    switch (ruleType){
        case RuleType.PUMP_FUN:
            supported.push(ComposeType.PUMP_FUN_QUICK)
            break;
        case RuleType.PUMP_FUN_MANAGED:
            break;
        case RuleType.PUMP_SWAP:
            break;
        case RuleType.PUMP_SWAP_MANAGED:
            break;
        case RuleType.PUMP_UP:
            supported.push(ComposeType.PUMP_UP_QUICK)
            break;
        case RuleType.PUMP_UP_MANAGED:
            break;
        case RuleType.JUPITER:
            break;
        case RuleType.JUPITER_MANAGED:
            break;


    }

    return (
        <div className={"flex flex-col border-l-4 border-yellow-300"}>
            <div className={"px-4 flex flex-row"}>
                <span className="pr-10 font-semibold text-yellow-300 text-3xl flex items-center">IF</span>
                <SelectComposeType
                    defaultType={type}
                    supported={supported}
                    onChange={(type) => {
                        if (type === "PUMP_FUN_QUICK") {
                            onTypeChange({...DEFAULT_COMPOSED_PUMP_FUN_QUICK} as unknown as Condition);
                        }

                        if (type === "PUMP_UP_QUICK") {
                            onTypeChange({...DEFAULT_COMPOSED_PUMP_UP_QUICK} as unknown as Condition);
                        }
                        // setType(type);
                    }}
                />
            </div>

            <div className={"pt-4"}>
                {type === ComposeType.PUMP_FUN_QUICK && (
                    <PumpFunComposeQuick
                        key={condition.id}
                        condition={condition as unknown as ComposedPumpFunQuick}
                        onChange={(updated) => {
                            onChange(updated as unknown as Condition);
                        }}/>
                )}

                {type === ComposeType.PUMP_UP_QUICK && (
                    <PumpUpComposeQuick
                        key={condition.id}
                        condition={condition as unknown as ComposedPumpUpQuick}
                        onChange={(updated) => {
                            onChange(updated as unknown as Condition);
                        }}/>
                )}
            </div>
        </div>
    )
}
